import { useState, useEffect } from "react";
import { subscribe } from "../utils/retryQueue";

/**
 * React hook that subscribes to the offline retry queue state.
 * Returns { pending, flushing, items }
 */
export function useRetryQueue() {
  const [state, setState] = useState({ pending: 0, flushing: false, items: [] });

  useEffect(() => {
    const unsubscribe = subscribe(setState);
    return unsubscribe;
  }, []);

  return state;
}
